var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAwesomeImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.284,
    height: 13.713,
    viewBox: "0 0 18.284 13.713",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-image",
    "data-name": "Icon awesome-image",
    d: "M16.57,18.213H1.714A1.714,1.714,0,0,1,0,16.5V6.214A1.714,1.714,0,0,1,1.714,4.5H16.57a1.714,1.714,0,0,1,1.714,1.714V16.5A1.714,1.714,0,0,1,16.57,18.213ZM4,6.5a2,2,0,1,0,2,2A2,2,0,0,0,4,6.5ZM2.285,15.927H16v-4L12.873,8.8a.429.429,0,0,0-.606,0L7.428,13.642,5.445,11.659a.429.429,0,0,0-.606,0L2.285,14.213Z",
    transform: "translate(0 -4.5)",
    opacity: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwesomeImage);
export default __webpack_public_path__ + "static/media/awesome-image.408f02e550a4ece55a23b50b953914ce.svg";
export { ForwardRef as ReactComponent };